import React, { useState, useEffect, useRef } from 'react'
import { IonSpinner, IonLabel } from '@ionic/react'
import 'react-circular-progressbar/dist/styles.css';
import { useAppData } from '../../context/appContext';
import { useHistory } from 'react-router';
// import Ecggraph from './components/ecggraph/ecggraph';
// import DTAL from '../../service/devicesubscription/mockdataservice';
import { DTAL } from '../../service/DTAL';
import { IoSyncSharp } from "react-icons/io5"
// import { Document, Page } from 'react-pdf';
import "./datasync.css"
//pdfme report creation
import { generate } from '@pdfme/generator';
import { text, image } from '@pdfme/schemas';
import { pdftemplate, vpsvgstring, vssvgstring,IMPLANT_DATE_OF_VISIT } from '../../util/config';
import { Viewer } from "@pdfme/ui";
import * as _ from "lodash";
// RxJS: selectedPatientSubject (BehaviorSubject) is received as a prop from Dashboard
import * as domtoimage from 'dom-to-image';
import * as htmltoimage from 'html-to-image';
import { saveAs } from 'file-saver';


import { SciChartSurface } from "scichart";
import { NumericAxis } from "scichart/Charting/Visuals/Axis/NumericAxis";
import { EAutoRange } from "scichart/types/AutoRange";
import { NumberRange } from "scichart/Core/NumberRange";
import { XyDataSeries } from "scichart/Charting/Model/XyDataSeries";
import { FastLineRenderableSeries } from "scichart/Charting/Visuals/RenderableSeries/FastLineRenderableSeries";
import { ENumericFormat } from "scichart/types/NumericFormat";
import { CustomAnnotation } from "scichart/Charting/Visuals/Annotations/CustomAnnotation";
import ChartJS from 'chart.js/auto';

import {Line} from 'react-chartjs-2';

import vsImagesvg from "../../assets/vs.svg"
import vpImagesvg from "../../assets/vp.svg"

import { unescapeCRFData } from '../../util/helpers/helperfunctions';
import { formatAppDate, formatAppDateTime } from '../../utils/dateFormat';

const chartDivId = 'scichart-root';



const SIX_MONTHS_MS = 15552000000 // 180 days (6 months)
// Ditto historical SSE can go quiet for tens of seconds between chunks; a short timeout was
// calling finish() early and cutting off most revisions (REST in Postman still returned full history).
const SSE_INACTIVITY_PERIOD = 120000; // 2 minutes — only treat stream as ended after long idle
const BATCH_PROCESS_INTERVAL = 3000; // process and display every 3 seconds during SSE
const MAX_SSE_DURATION = 1800000;     // 30 min safety cap for very large historical streams

// Features that carry session-relevant data; SSE events without any of these are skipped
const SYNC_RELEVANT_FEATURES = new Set([
  'deviceparameters', 'egmpacketdata', 'devicestatus',
  'batteryvoltage', 'leadimpedanceweeklymin', 'ventricularmarkers',
  'batteryparameter',
]);
const MAX_ECG_POINTS = 2000;
const COLOR_GREEN = "#00FF00";
const STROKE_THICKNESS = 2;
let selectedDatasynclog = null;
let selectedDeviceData = '' //device assoicated with the selected patient

let pdfviewerwindow = null;

let dtalService = new DTAL(null);

let deviceUpdates = new Map();
let datasynclogs = new Map();
let sessiondatasynclogs = new Map();
let subjectData = {};
let implantData = {};
let fetchAbortFlag = null; // abort signaling for windowed fetch

const heightpercent = 0.15; //30% of window height
const widthpercent = 0.15;

export const scichartlicensekey = process.env.REACT_APP_SCICHART_LICENSE_KEY || '';

let lineChartData = {};
const vsImage = new Image().src={vsImagesvg};
const vpImage = new Image().src={vpImagesvg};

// Add this CSS rule for transparent canvas (if not already present)
if (!document.getElementById('transparent-canvas-style')) {
  const style = document.createElement('style');
  style.id = 'transparent-canvas-style';
  style.innerHTML = `
    canvas {
      background: transparent !important;
    }
  `;
  document.head.appendChild(style);
}

const drawExample = async (
  data, vsValues, vpValues
) => {


  SciChartSurface.setRuntimeLicenseKey(scichartlicensekey);
  const { sciChartSurface, wasmContext } = await SciChartSurface.create(chartDivId, {
    //widthAspect: window.innerWidth, heightAspect: calyanConstant.CHART_HEIGHT
    widthAspect: window.innerWidth * widthpercent, heightAspect: window.innerHeight * heightpercent,
  });
  const xAxis = new NumericAxis(wasmContext, {
    autoRange: EAutoRange.Once,
    // axisTitle: "Time(s)",
    // visibleRange: new NumberRange(0, calyanConstant.DEFAULT_EGM_XLENGTH), 
    autoTicks: false, majorDelta: 200, minorDelta: 25
  });
  xAxis.labelProvider.formatLabel = (dataValue, format) => {
    return dataValue / 200;  //200 samples per sec
  };
  // xAxis.visibleRangeLimit = new NumberRange(0, calyanConstant.DEFAULT_EGM_XLENGTH);

  const yAxis = new NumericAxis(wasmContext, {
    autoRange: EAutoRange.Always,
    growBy: new NumberRange(0.1, 0.1),
    axisTitle: "Voltage(mV)",
    axisTitleStyle: { fontSize: 16 },
    autoTicks: false,
    majorDelta: 0.2,
    minorDelta: 0.04,
    drawMajorTickLines: false,
    drawMajorGridLines: false,
    drawMinorGridLines: false,
    drawMinorTickLines: false,
    visibleRange: new NumberRange(13, 30)
  });
  //yAxis.labelProvider.numericFormat = ENumericFormat.Decimal;
  // yAxis.visibleRangeLimit = new NumberRange(13, 15);

  sciChartSurface.xAxes.add(xAxis);
  sciChartSurface.yAxes.add(yAxis);

  // Create and fill initial data series
  const dataSeries1 = new XyDataSeries(wasmContext);

  //check there was a previous draw that got switched
  if (data) {
    //append known points with annotation (if any)
    //let lastxIndex = currentPoint > POINTS_LOOP ? POINTS_LOOP:(currentPoint) % POINTS_LOOP;
    let lastxIndex = MAX_ECG_POINTS;

    for (let i = 0; i < lastxIndex; i++) {
      dataSeries1.append(i, data[i]);
      if (vsValues[i]) {
        let custannotation = new CustomAnnotation({
          x1: i,
          y1: data[i],
          // verticalAnchorPoint: EVerticalAnchorPoint.Top,
          // horizontalAnchorPoint: EHorizontalAnchorPoint.Center,
          //TODO replace the svg for vs
          svgString: vssvgstring

        });
        //sciChartSurface.annotations.insert(xArr[i],
        sciChartSurface.annotations.add(custannotation);
      }

      if (vpValues[i]) {
        //sciChartSurface.annotations.set(xArr[i],
        let custannotation = new CustomAnnotation({
          x1: i,
          y1: data[i],
          // verticalAnchorPoint: EVerticalAnchorPoint.Top,
          // horizontalAnchorPoint: EHorizontalAnchorPoint.Center,
          svgString: vpsvgstring

        });

        sciChartSurface.annotations.add(custannotation);

      }

    }


  }

  sciChartSurface.renderableSeries.add(
    new FastLineRenderableSeries(wasmContext, {
      strokeThickness: STROKE_THICKNESS,
      stroke: COLOR_GREEN,
      dataSeries: dataSeries1
    })
  );

  return sciChartSurface;
}
//plugin to fix the black background issue with chart exported jpeg image
const jpegPlugin = {
  id: 'jpegbackgroundfix',
  beforeDraw: function(chartInstance) {
    var ctx = chartInstance.ctx;
    ctx.save();
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, chartInstance.width, chartInstance.height);
    ctx.restore();
    }  
}

// ECG grid plugin: draws minor (1mm) and major (5mm) grid lines similar to programmer view
const ecgGridPlugin = {
  id: 'ecgGrid',
  beforeDraw(chart, args, pluginOptions) {
    const { ctx, chartArea, scales } = chart;
    if (!chartArea || !scales?.x || !scales?.y) return;
    const { left, top, right, bottom } = chartArea;
    const xScale = scales.x;
    const yScale = scales.y;

    const samplingRate = pluginOptions?.samplingRate || 300; // samples/sec
    const minorSec = 0.04; // 1mm at 25 mm/s
    const majorSec = 0.2;  // 5mm at 25 mm/s

    ctx.save();

    // Vertical minor lines every 0.04s
    ctx.lineWidth = 0.5;
    ctx.strokeStyle = 'rgba(255,0,0,0.15)';
    const windowSeconds = (xScale.max - xScale.min) / samplingRate;
    for (let t = 0; t <= windowSeconds + 1e-6; t += minorSec) {
      const value = xScale.min + t * samplingRate;
      const x = xScale.getPixelForValue(value);
      ctx.beginPath();
      ctx.moveTo(x, top);
      ctx.lineTo(x, bottom);
      ctx.stroke();
    }

    // Vertical major lines every 0.2s
    ctx.lineWidth = 1.0;
    ctx.strokeStyle = 'rgba(255,0,0,0.35)';
    for (let t = 0; t <= windowSeconds + 1e-6; t += majorSec) {
      const value = xScale.min + t * samplingRate;
      const x = xScale.getPixelForValue(value);
      ctx.beginPath();
      ctx.moveTo(x, top);
      ctx.lineTo(x, bottom);
      ctx.stroke();
    }

    // Horizontal lines in mV: minor 0.1 mV, major 0.5 mV
    const minorMv = 0.1;
    const majorMv = 0.5;
    const yMin = yScale.min;
    const yMax = yScale.max;

    // Minor horizontals
    ctx.lineWidth = 0.5;
    ctx.strokeStyle = 'rgba(255,0,0,0.15)';
    let startMinor = Math.ceil(yMin / minorMv) * minorMv;
    for (let v = startMinor; v <= yMax + 1e-6; v = +(v + minorMv).toFixed(10)) {
      const y = yScale.getPixelForValue(v);
      ctx.beginPath();
      ctx.moveTo(left, y);
      ctx.lineTo(right, y);
      ctx.stroke();
    }

    // Major horizontals
    ctx.lineWidth = 1.0;
    ctx.strokeStyle = 'rgba(255,0,0,0.35)';
    let startMajor = Math.ceil(yMin / majorMv) * majorMv;
    for (let v = startMajor; v <= yMax + 1e-6; v = +(v + majorMv).toFixed(10)) {
      const y = yScale.getPixelForValue(v);
      ctx.beginPath();
      ctx.moveTo(left, y);
      ctx.lineTo(right, y);
      ctx.stroke();
    }

    ctx.restore();
    }  
}

ChartJS.register(
  jpegPlugin,
  ecgGridPlugin
);



ChartJS.defaults.elements.line.borderWidth = 1


const EGM_VOLTAGE_SPAN_MV = 15.1; // exact vertical span to lock charts
let lockedYAxisCenterMv = 22.0; // keep a consistent baseline across charts (mV)

const Datasync = ({selectedPatientSubject}) => {


  const history = useHistory()
  const [userData, setUserData] = useState()
  const [batteryValue, setBatteryValue] = useState()
  const [syncData, setSyncData] = useState()
  const [syncDataDisplay, setSyncDataDisplay] = useState()
  const [indexValue, setIndexValue] = useState()
  const [selected, setSelected] = useState()
  const [report, setReport] = useState(false)  //to indicate availability of report
  const [isLoaded,setIsLoaded] = useState(false)
  const [isDataSyncAvailable,setIsDataSyncAvailable] = useState(true)  
  const [isLineChartDataAvailable,setIsLineChartDataAvailable] = useState(false)  
  const [loadingProgress, setLoadingProgress] = useState("")
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)



  const appData = useAppData()
  const chartRef = useRef(null);
  const hiddenChartRef = useRef(null); // Dedicated ref for image generation

  // Use React context instead of localStorage(No PHI in localStorage)
  const devices = appData.allPatientData || [];

  // Process a batch of device updates into datasynclogs and sessiondatasynclogs
  const processUpdatesIntoSessions = (updates) => {
    let sseupdates = Array.from(updates.values());
    let duGroup = _.groupBy(sseupdates, ({ _modified }) => _modified.split('T')[0]);
    if (_.isEmpty(duGroup)) return;

    _.forEachRight(duGroup, function (devupdates, day) {
      let dayMap = datasynclogs.get(day);
      if (!dayMap) {
        dayMap = new Map();
        datasynclogs.set(day, dayMap);
        dayMap.set('parameters', []);
        dayMap.set('egm', []);
        dayMap.set('errors', []);
        dayMap.set('currentleadimpedance', []);
        dayMap.set('markers', []);
        dayMap.set('batteryvoltage', []);
        dayMap.set('daysToEos', []);
      }

      _.forEachRight(devupdates, function (du) {
        if ((du.features?.deviceparameters?.properties)) {
          let parametersample = {
            parameterinfo: du.features.deviceparameters.properties,
            ts: du._modified
          }
          let storedparametersamples = dayMap.get('parameters');
          storedparametersamples.push(parametersample);
          dayMap.set('parameters', storedparametersamples);
        }

        // FIX #8-10: Property names are all lowercase in Ditto (voltagevalues, vsmarkers, vpmarkers)
        if ((du.features?.egmpacketdata?.properties?.voltagevalues)) {
          if (!_.isEmpty(du.features.egmpacketdata.properties.voltagevalues)) {
            let streambuffer = {
              voltageValues: du.features.egmpacketdata.properties.voltagevalues,
              vsMarkers: du.features.egmpacketdata.properties.vsmarkers,
              vpMarkers: du.features.egmpacketdata.properties.vpmarkers,
              timestamp: du.features.egmpacketdata.properties.timestamp,
              ts: du._modified
            }
            let storedsamples = dayMap.get('egm');
            storedsamples.push(streambuffer);
            dayMap.set('egm', storedsamples);
          }
        }

        // FIX #14: Read mainprocessorerror and pacingengineerror (not errors.processed)
        const mpErr = du.features?.devicestatus?.properties?.mainprocessorerror;
        const peErr = du.features?.devicestatus?.properties?.pacingengineerror;
        if (mpErr || peErr) {
          let errorinfo = {
            ts: du._modified,
            errcodes: { mainprocessorerror: mpErr, pacingengineerror: peErr }
          }
          let storederrorsamples = dayMap.get('errors');
          storederrorsamples.push(errorinfo);
          dayMap.set('errors', storederrorsamples);
        }

        // Feature "batteryvoltage" and property "batteryvoltage" match RawDataProcessor output
        if (du.features?.batteryvoltage?.properties?.batteryvoltage) {
          let batteryinfo = {
            ts: du._modified,
            batteryvalue: du.features.batteryvoltage.properties.batteryvoltage
          }
          let storedbatterysamples = dayMap.get('batteryvoltage');
          storedbatterysamples.push(batteryinfo);
          dayMap.set('batteryvoltage', storedbatterysamples);
        }

        // Feature "batteryparameter" carries "Days to EOS" — historical
        // estimated longevity per interrogation. Captured per-session so
        // each sync log shows its own value (not the latest device state).
        const daysEos = du.features?.batteryparameter?.properties?.["Days to EOS"];
        if (daysEos != null) {
          let eosinfo = { ts: du._modified, days: daysEos };
          let storedEosSamples = dayMap.get('daysToEos');
          storedEosSamples.push(eosinfo);
          dayMap.set('daysToEos', storedEosSamples);
        }

        // Feature "leadimpedanceweeklymin" with property "impedancevaluesohms" array
        if (du.features?.leadimpedanceweeklymin?.properties?.impedancevaluesohms) {
          let impedanceArr = du.features.leadimpedanceweeklymin.properties.impedancevaluesohms;
          let leadZinfo = {
            ts: du._modified,
            currentleadimpedance: impedanceArr[0]
          }
          let storedZsamples = dayMap.get('currentleadimpedance');
          storedZsamples.push(leadZinfo);
          dayMap.set('currentleadimpedance', storedZsamples);
        }

        // Feature "ventricularmarkers" with vspercentage/vppercentage
        if (du.features?.ventricularmarkers?.properties?.vspercentage !== undefined) {
          let vs = du.features.ventricularmarkers.properties.vspercentage ?? -1;
          let vp = du.features.ventricularmarkers.properties.vppercentage ?? -1;
          let markerinfo = {
            ts: du._modified,
            vs,
            vp
          }
          let storedmarkers = dayMap.get('markers');
          storedmarkers.push(markerinfo);
          dayMap.set('markers', storedmarkers);
        }
      });

      // Segregate into sessions based on parameters
      let sessionParameters = dayMap.get('parameters')
      let ainterrogatedts = [];
      if(_.isEmpty(sessionParameters)) {
        let daySessionMap = new Map();
        sessiondatasynclogs.set(day, daySessionMap);
        daySessionMap.set('parameters', null);
        daySessionMap.set('egm', dayMap.get('egm'));
        let entity = dayMap.get('errors');
        daySessionMap.set('errors', _.isEmpty(entity)?null:entity[0]);
        entity = dayMap.get('currentleadimpedance');
        daySessionMap.set('currentleadimpedance', _.isEmpty(entity)?-1:entity[0].currentleadimpedance);
        entity = dayMap.get('markers');
        daySessionMap.set('vp', _.isEmpty(entity)?-1:entity[0].vp);
        daySessionMap.set('vs', _.isEmpty(entity)?-1:entity[0].vs);
        entity = dayMap.get('batteryvoltage');
        daySessionMap.set('batteryvoltage', _.isEmpty(entity)?-1:entity[0].batteryvalue);
        entity = dayMap.get('daysToEos');
        daySessionMap.set('daysToEos', _.isEmpty(entity)?-1:entity[0].days);
      } else {
        _.forEach(sessionParameters, function (parametersample) {
          let interrogatedts = parametersample.ts; ainterrogatedts.push(interrogatedts);
          let daySessionMap = sessiondatasynclogs.get(interrogatedts);
          if (!daySessionMap) {
            daySessionMap = new Map();
            sessiondatasynclogs.set(interrogatedts, daySessionMap);
            daySessionMap.set('parameters', parametersample.parameterinfo);
            daySessionMap.set('egm', []);
            daySessionMap.set('errors', {});
            daySessionMap.set('currentleadimpedance', -1);
            daySessionMap.set('vp', -1);
            daySessionMap.set('vs', -1);
            daySessionMap.set('batteryvoltage', -1);
            daySessionMap.set('daysToEos', -1);
          }
        })
        if(!_.isEmpty(ainterrogatedts))
        {
          ainterrogatedts.sort();

          let egm10secsamples = dayMap.get('egm');
          _.forEach(egm10secsamples, function (egm10secsample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts, egm10secsample.ts) - 1;
            if (interrogationIdx < 0) interrogationIdx = 0;
            if (interrogationIdx >= ainterrogatedts.length) interrogationIdx = ainterrogatedts.length - 1;
            const sessionKey = ainterrogatedts[interrogationIdx];
            let daySessionMap = sessiondatasynclogs.get(sessionKey);
            if (!daySessionMap) return;
            let storedsamples = daySessionMap.get('egm');
            storedsamples.push(egm10secsample);
            daySessionMap.set('egm', storedsamples);
          })

          let errorsamples = dayMap.get('errors');
          _.forEach(errorsamples, function (errorsample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts, errorsample.ts) - 1;
            if (interrogationIdx < 0 || interrogationIdx >= ainterrogatedts.length) return;
            let daySessionMap = sessiondatasynclogs.get(ainterrogatedts[interrogationIdx]);
            if (!daySessionMap) return;
            let errinfo = daySessionMap.get('errors');
            if(_.isEmpty(errinfo)) daySessionMap.set('errors', errorsample);
          })

          let batteryVsamples = dayMap.get('batteryvoltage');
          _.forEach(batteryVsamples, function (batteryVsample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts,batteryVsample.ts) - 1;
            if (interrogationIdx >= 0 && interrogationIdx < ainterrogatedts.length) {
              let sessionKey = ainterrogatedts[interrogationIdx];
              let daySessionMap = sessiondatasynclogs.get(sessionKey);
              let batteryV = daySessionMap.get('batteryvoltage');
              if(batteryV == -1) {
                daySessionMap.set('batteryvoltage', batteryVsample.batteryvalue);
              }
            }
          })

          // Bind Days-to-EOS samples to their owning session (first-write-wins).
          let eosSamples = dayMap.get('daysToEos');
          _.forEach(eosSamples, function (eosSample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts, eosSample.ts) - 1;
            if (interrogationIdx >= 0 && interrogationIdx < ainterrogatedts.length) {
              let sessionKey = ainterrogatedts[interrogationIdx];
              let daySessionMap = sessiondatasynclogs.get(sessionKey);
              let existing = daySessionMap.get('daysToEos');
              if (existing == null || existing === -1) {
                daySessionMap.set('daysToEos', eosSample.days);
              }
            }
          })

          let leadZsamples = dayMap.get('currentleadimpedance');
          _.forEach(leadZsamples, function (leadZsample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts, leadZsample.ts)  - 1;
            if (interrogationIdx < 0 || interrogationIdx >= ainterrogatedts.length) return;
            let daySessionMap = sessiondatasynclogs.get(ainterrogatedts[interrogationIdx]);
            if (!daySessionMap) return;
            let leadZV = daySessionMap.get('currentleadimpedance');
            if(leadZV == -1) daySessionMap.set('currentleadimpedance', leadZsample.currentleadimpedance);
          })

          let markersamples = dayMap.get('markers');
          _.forEach(markersamples, function (markersample){
            let interrogationIdx = _.sortedIndex(ainterrogatedts, markersample.ts) - 1;
            if (interrogationIdx < 0 || interrogationIdx >= ainterrogatedts.length) return;
            let daySessionMap = sessiondatasynclogs.get(ainterrogatedts[interrogationIdx]);
            if (!daySessionMap) return;
            let vp = daySessionMap.get('vp');
            let vs = daySessionMap.get('vs');
            if(vp == -1) daySessionMap.set('vp', markersample.vp);
            if(vs == -1) daySessionMap.set('vs', markersample.vs);
          })
        }
      }
    });
  };

  const getDataSync = async (deviceId) => {
    // Abort any previous fetch in progress
    if (fetchAbortFlag) fetchAbortFlag.aborted = true;
    const abortFlag = { aborted: false };
    fetchAbortFlag = abortFlag;

    setIsLoaded(false);
    setLoadingMore(false);
    setIsDataSyncAvailable(true);
    setLoadingProgress("Initializing data sync...");
    // Clear previous data
    deviceUpdates.clear();
    datasynclogs.clear();
    sessiondatasynclogs.clear();
    setSyncData([]);
    if(pdfviewerwindow) {
      pdfviewerwindow.close();
    }

    selectedDeviceData = _.find(devices, function (o) { return o.thingId == deviceId; });

    // Load eCRF data first
    setLoadingProgress("Loading patient information...");
    try {
      const [eCRFSubjectData, eCRFImplantData] = await Promise.all([
        dtalService.get("eCRF_subjects:"+selectedDeviceData.attributes.subjectId),
        dtalService.get("eCRF_implant:"+selectedDeviceData.attributes.subjectId)
      ]);
      subjectData = eCRFSubjectData[0];
      implantData = eCRFImplantData[0]?.features?.implant?.properties?.values;
      if(!_.isEmpty(implantData)) {
        implantData = unescapeCRFData(implantData);
      }
    } catch (err) {
      console.error("Error loading eCRF data:", err);
    }

    if (abortFlag.aborted) return;

    // Single SSE for the full 6-month range; render sync logs as events arrive
    const now = new Date();
    const sixMonthsAgo = new Date(now.getTime() - SIX_MONTHS_MS);
    const sseFields = "thingId,features,_revision,_modified";
    const streamKey = "history";

    setLoadingProgress("Please wait. Loading Sync Logs...");

    let batchTimer = null;
    let inactivityTimer = null;
    let safetyTimer = null;
    let noDataTimer = null;
    let subscription = null;
    let isDone = false;
    let hasShownData = false;

    // Store an SSE response if it carries sync-relevant features
    const addToDeviceUpdates = (response) => {
      const featureKeys = response.features ? Object.keys(response.features) : [];
      if (!featureKeys.some(k => SYNC_RELEVANT_FEATURES.has(k))) return;

      let baseKey =
        response._revision != null && response._revision !== undefined
          ? `r:${response._revision}`
          : String(response._modified ?? '');
      let key = baseKey;
      let n = 0;
      while (deviceUpdates.has(key)) {
        n += 1;
        key = `${baseKey}#${n}`;
      }
      deviceUpdates.set(key, response);
    };

    // Rebuild sessions from all stored events and update UI
    const processBatch = () => {
      if (abortFlag.aborted || isDone || deviceUpdates.size === 0) return;

      datasynclogs.clear();
      sessiondatasynclogs.clear();
      processUpdatesIntoSessions(deviceUpdates);

      let days = Array.from(sessiondatasynclogs.keys());
      days.sort((a, b) => b.localeCompare(a)); // newest first
      setSyncData([...days]);

      if (!hasShownData && days.length > 0) {
        setIsLoaded(true);
        setIsDataSyncAvailable(true);
        setLoadingMore(false);
        setLoadingProgress("");
        hasShownData = true;
        // Data found — cancel the no-data timer
        if (noDataTimer) { clearTimeout(noDataTimer); noDataTimer = null; }
      }
    };

    // Called when the SSE stream ends or safety timer fires
    const finish = () => {
      if (isDone) return;
      isDone = true;
      if (batchTimer) clearInterval(batchTimer);
      if (inactivityTimer) clearTimeout(inactivityTimer);
      if (safetyTimer) clearTimeout(safetyTimer);
      if (noDataTimer) clearTimeout(noDataTimer);
      if (subscription) subscription.unsubscribe();
      dtalService.unsubscribe(streamKey);

      if (!abortFlag.aborted) {
        // Final processing — rebuild sessions one last time
        datasynclogs.clear();
        sessiondatasynclogs.clear();
        if (deviceUpdates.size > 0) {
          processUpdatesIntoSessions(deviceUpdates);
        }
        let days = Array.from(sessiondatasynclogs.keys());
        days.sort((a, b) => b.localeCompare(a));
        setSyncData([...days]);

        setLoadingMore(false);
        setLoadingProgress("");
        if (sessiondatasynclogs.size === 0) {
          setIsLoaded(true);
          setIsDataSyncAvailable(false);
        } else {
          setIsLoaded(true);
          setIsDataSyncAvailable(true);
        }
      }
    };

    // Open a single SSE connection for the full 6-month range
    dtalService.unsubscribe(streamKey);
    let sseSubject;
    try {
      sseSubject = await dtalService.gethistorical(
        selectedDeviceData.thingId, null, null,
        sixMonthsAgo.toISOString(), now.toISOString(),
        sseFields, streamKey
      );
    } catch (err) {
      console.error("Error starting historical SSE:", err);
      setIsLoaded(true);
      setIsDataSyncAvailable(false);
      setLoadingProgress("");
      return;
    }

    if (abortFlag.aborted) return;

    if (!sseSubject) {
      setIsLoaded(true);
      setIsDataSyncAvailable(false);
      setLoadingProgress("");
      return;
    }

    // Subscribe: process each event as it arrives, batch-render every 3s
    setLoadingMore(true);
    batchTimer = setInterval(processBatch, BATCH_PROCESS_INTERVAL);
    safetyTimer = setTimeout(finish, MAX_SSE_DURATION);

    // If no sync sessions found within 5s, stop showing loading and show "no data"
    noDataTimer = setTimeout(() => {
      if (!hasShownData && !isDone) {
        finish();
      }
    }, 5000);

    subscription = sseSubject.subscribe({
      next: (response) => {
        if (isDone || abortFlag.aborted) return;
        addToDeviceUpdates(response);
        // Reset inactivity timer on every event (relevant or not — proves stream is alive)
        if (inactivityTimer) clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(finish, SSE_INACTIVITY_PERIOD);
      },
      // Ditto closes the SSE when all historical events are sent;
      // the onerror handler in DTAL.ts calls subject.complete() which triggers this
      complete: () => {
        finish();
      }
    });

    // Fallback inactivity timer in case stream sends nothing at all
    inactivityTimer = setTimeout(finish, SSE_INACTIVITY_PERIOD);
  }



  useEffect(() => {
    const selectedPatientSubscription = selectedPatientSubject.subscribe(selectedPatientId => {
      if(!selectedPatientId) {

    appData.setSelected("Data Sync")
    if (appData?.appUserData == null) {
      if (devices && devices.length > 0) {
        getDataSync(devices[0]?.thingId)
      }
    } else {
      getDataSync(appData?.appUserData.thingId)
    }} else {
      if (devices && devices.length > 0) {
        let device = _.find(devices,function (o) { return o.attributes.subjectId == selectedPatientId; });
        if(device) getDataSync(device.thingId)
      }
    }})

    return () => {
      selectedPatientSubscription.unsubscribe();
      // Abort any in-progress fetch and close SSE
      if (fetchAbortFlag) fetchAbortFlag.aborted = true;
      dtalService.unsubscribe('history');
    };
  }, [devices.length])


  const drawLineChart = async (ydata,vs,vp, modifiedtime, options = {}) => {
    return new Promise((resolve) => {
      setIsLineChartDataAvailable(false);
      // Create a temporary delay to ensure previous chart is cleared
      setTimeout(() => {
        const samplingRate = options.samplingRate || 300; // samples/sec
        const windowSeconds = options.windowSeconds || 10; // 10s window
        const autoScaleY = options.autoScaleY !== false; // default: true
        let yMin; let yMax; let tickStep;
        if (autoScaleY) {
          const finiteVals = ydata.filter((v) => Number.isFinite(v));
          const dataMin = finiteVals.length ? Math.min(...finiteVals) : 0;
          const dataMax = finiteVals.length ? Math.max(...finiteVals) : 1;
          const range = Math.max(0.1, dataMax - dataMin);
          const pad = Math.max(0.1, range * 0.1);
          yMin = dataMin - pad;
          yMax = dataMax + pad;
          tickStep = (yMax - yMin) / 10;
        } else {
          const voltageSpanMv = options.voltageSpanMv || EGM_VOLTAGE_SPAN_MV; // locked span
          const yCenter = options.yCenterMv != null ? options.yCenterMv : lockedYAxisCenterMv; // locked baseline
          yMin = yCenter - voltageSpanMv / 2;
          yMax = yCenter + voltageSpanMv / 2;
          tickStep = voltageSpanMv / 10;
        }

        const xyData = ydata.map((y, i) => ({ x: i, y }));
        lineChartData = {
          data: {
            datasets: [
              {
                data: xyData,
                pointRadius: 0,
                borderColor: '#00AA00',
                borderWidth: 2,
                label: modifiedtime,
                fill: false
              },
              {
                data: xyData,
                pointStyle: vs.map((value)=> value ? 'triangle': 'circle'),
                pointRadius: vs.map((value)=> value ? 5: 0),
                borderColor: '#00FF00',
                backgroundColor: '#00FF00',
                label: 'Sensed',
                showLine: false,
                fill: false
              },
              {
                data: xyData,
                pointStyle: vp.map((value)=> value ? 'triangle': 'circle'),        
                pointRadius: vp.map((value)=> value ? 5: 0),
                borderColor: '#0000FF',
                backgroundColor: '#0000FF', 
                label: 'Paced',
                showLine: false,
                fill: false
              }
            ],
            labels: ydata.map((y,x) => x)
          },      
          options: {
            animation: {
              duration: 0 // Disable animations for faster rendering
            },
            responsive: false, // Important: disables auto-resize
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              ecgGrid: { samplingRate }
            },
            // No backgroundColor here!
            scales: {
              x: {
                  type: 'linear',
                  max: samplingRate * windowSeconds,
                  min: 0,
                  title: { display: true, text: 'Time (s)' },
                  ticks: {
                    maxTicksLimit: 11,
                    stepSize: samplingRate,
                    callback: function(value) { return Math.round(value / samplingRate); }
                  },
                  grid: { display: false }
              },
              y: {
                position: 'left',
                title: {
                  display: true,
                  text: 'Voltage (mV)'
                },
                min: yMin,
                max: yMax,
                ticks: {
                  maxTicksLimit: 11,
                  stepSize: tickStep,
                  callback: function(value) { return value.toFixed ? value.toFixed(1) : value; }
                },
                grid: { display: false }
              }          
            }
          }
        }

        setIsLineChartDataAvailable(true);
        // Give time for the chart to render completely
        setTimeout(() => {
          console.log("Chart should be rendered, resolving promise");
          resolve();
        }, 100);
      }, 50);
    });
  }

  // New function to process EGM data similar to programmer
  const processEgmDataForCharts = async (egmData, chartimages, charttime) => {
    console.log("Processing EGM data for charts:", egmData);
    
    // Constants similar to programmer
    const SAMPLING_RATE = 200; // Hz (200 samples per second)
    const SECONDS_PER_SEGMENT = 10; // 10 seconds per chart
    const SAMPLES_PER_SEGMENT = SAMPLING_RATE * SECONDS_PER_SEGMENT; // 3000 samples per 10-second segment
    const COLOR_GREEN = "#00FF00";
    const STROKE_THICKNESS = 2;
    
    // Process voltage values from egmpacketdata
    let voltageValues = [];
    let vsValues = [];
    let vpValues = [];
    
    if (egmData.voltageValues && Array.isArray(egmData.voltageValues)) {
      voltageValues = egmData.voltageValues;
      
      // Process VS markers (ventricular sensed events)
      if (egmData.vsValues && Array.isArray(egmData.vsValues)) {
        vsValues = egmData.vsValues.map(val => val > 0 ? 1 : 0);
      }
      
      // Process VP markers (ventricular paced events)  
      if (egmData.vpValues && Array.isArray(egmData.vpValues)) {
        vpValues = egmData.vpValues.map(val => val > 0 ? 1 : 0);
      }
      
      console.log("Processed EGM data:", {
        voltageValues: voltageValues.length,
        vsValues: vsValues.length,
        vpValues: vpValues.length,
        totalVSEvents: vsValues.filter(v => v > 0).length,
        totalVPEvents: vpValues.filter(v => v > 0).length
      });
      
      // Generate 10-second segments
      const segments = [];
      
      for (let startIndex = 0; startIndex < voltageValues.length; startIndex += SAMPLES_PER_SEGMENT) {
        const endIndex = Math.min(startIndex + SAMPLES_PER_SEGMENT, voltageValues.length);
        const segmentData = voltageValues.slice(startIndex, endIndex);
        const segmentVs = vsValues.slice(startIndex, endIndex);
        const segmentVp = vpValues.slice(startIndex, endIndex);
        
        if (segmentData.length === SAMPLES_PER_SEGMENT) {
          const startTimeSeconds = startIndex / SAMPLING_RATE;
          const endTimeSeconds = endIndex / SAMPLING_RATE;
          
          segments.push({
            data: segmentData,
            vs: segmentVs,
            vp: segmentVp,
            label: `EGM ${startTimeSeconds.toFixed(1)}s - ${endTimeSeconds.toFixed(1)}s`,
            startTime: startTimeSeconds,
            endTime: endTimeSeconds
          });
        }
      }
      
      console.log(`Generated ${segments.length} segments from EGM data`);

      // Keep only the last 5 segments (most recent data) for the PDF
      const chartSegments = segments.slice(-5);
      console.log(`Using last ${chartSegments.length} of ${segments.length} segments for PDF`);

      // Generate chart for each 10-second segment
      for (let i = 0; i < chartSegments.length; i++) {
        const segment = chartSegments[i];
        if (segment.data.length > 0) {
          console.log(`Generating EGM chart ${i + 1} (${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s) with ${segment.data.length} data points...`);
          
          await drawLineChart(segment.data, segment.vs, segment.vp, segment.label, { samplingRate: 200, windowSeconds: 10, voltageSpanMv: 15.1 });
          console.log(`EGM chart ${i + 1} rendered, waiting for complete render...`);
          await new Promise((r) => setTimeout(r, 1000)); // Wait for chart to render
          
          // Capture chart as base64
          try {
            console.log(`Attempting to capture EGM chart ${i + 1} as base64...`);
            const chartForCapture = hiddenChartRef.current || chartRef.current;
            const base64Image = await captureChartAsBase64({ current: chartForCapture });
            
            if (base64Image && base64Image.startsWith('data:image')) {
              chartimages.push(base64Image);
              // Use time-based timestamp instead of current time
              const timeLabel = `${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s`;
              charttime.push(timeLabel);
              console.log(`EGM chart ${i + 1} captured successfully:`, {
                imageLength: base64Image.length,
                totalImages: chartimages.length,
                segmentSize: segment.data.length,
                timeRange: timeLabel,
                imagePreview: base64Image.substring(0, 50) + "..."
              });
            } else {
              console.error(`Invalid base64 image for EGM chart ${i + 1}:`, base64Image);
            }
          } catch (error) {
            console.error(`Failed to capture EGM chart ${i + 1}:`, {
              error: error.message,
              chartRefExists: !!(hiddenChartRef.current || chartRef.current),
              isLineChartDataAvailable
            });
          }
          
          await new Promise((r) => setTimeout(r, 200)); // Small delay between charts
        }
      }
    } else {
      console.log("No voltage values found in EGM data");
    }
    
    return { chartimages, charttime };
  };

  // New function to process session-based EGM data
  const processSessionEgmData = async (astreambuffer, chartimages, charttime) => {
    console.log("Processing session-based EGM data");
    
    const SAMPLING_RATE = 300; // Hz (300 samples per second)
    const SECONDS_PER_SEGMENT = 10; // 10 seconds per chart
    const SAMPLES_PER_SEGMENT = SAMPLING_RATE * SECONDS_PER_SEGMENT; // 3000 samples per 10-second segment
    
    if (astreambuffer) {
      // Accumulate all packets in the session before segmenting
        let heartRateValues = [];
        let vsValues = [];
        let vpValues = [];
      for (let iIdx = 0; iIdx < astreambuffer.length; iIdx++) {
        let streambuffer = astreambuffer[iIdx];

        if (streambuffer && streambuffer.streams) {
          console.log("streambuffer::::::::::", streambuffer);
          for (let iSecIdx = 0; iSecIdx < streambuffer.streams.length; iSecIdx++) {
            let stream = streambuffer.streams[iSecIdx];
            charttime.push(formatAppDateTime(streambuffer.ts));
            if (stream) {
              for (let iMSecIdx = 0; iMSecIdx < stream.length; iMSecIdx++) {
                let sample = stream[iMSecIdx];
                if (sample) {
                  // Handle both CSV format and direct array format
                  if (sample.heartRateValues) {
                    if (typeof sample.heartRateValues === 'string') {
                      // Old CSV format
                      let decodedValues = sample.heartRateValues.split(",").filter(x => x.trim().length && !isNaN(x)).map(Number);
                      heartRateValues = _.concat(heartRateValues, decodedValues);
                      decodedValues = sample.vs.split(",").filter(x => x.trim().length && !isNaN(x)).map(Number);
                      vsValues = _.concat(vsValues, decodedValues);
                      decodedValues = sample.vp.split(",").filter(x => x.trim().length && !isNaN(x)).map(Number);
                      vpValues = _.concat(vpValues, decodedValues);
                    }
                  }
                }
              }
            }
          }
        }
        // New format: direct arrays on packet (voltageValues, vsMarkers, vpMarkers)
        else if (streambuffer && Array.isArray(streambuffer.voltageValues)) {
          // Use the first packet ts for labeling
          if (charttime.length === 0) {
            charttime.push(formatAppDateTime(streambuffer.ts || streambuffer.timestamp));
          }
          heartRateValues = heartRateValues.concat(streambuffer.voltageValues);
          if (Array.isArray(streambuffer.vsMarkers)) {
            vsValues = vsValues.concat(streambuffer.vsMarkers);
          }
          if (Array.isArray(streambuffer.vpMarkers)) {
            vpValues = vpValues.concat(streambuffer.vpMarkers);
          }
        }
      }
        if (heartRateValues.length > 0) {
          console.log("Generating charts from session data:", {
            heartRateValues: heartRateValues.length,
            vsValues: vsValues.length,
            vpValues: vpValues.length,
            totalVSEvents: vsValues.filter(v => v > 0).length,
            totalVPEvents: vpValues.filter(v => v > 0).length
          });
          
          // Generate 10-second segments
          const segments = [];
          for (let startIndex = 0; startIndex < heartRateValues.length; startIndex += SAMPLES_PER_SEGMENT) {
            const endIndex = Math.min(startIndex + SAMPLES_PER_SEGMENT, heartRateValues.length);
            const segmentData = heartRateValues.slice(startIndex, endIndex);
            const segmentVs = vsValues.slice(startIndex, endIndex);
            const segmentVp = vpValues.slice(startIndex, endIndex);
            console.log("Segment data:::::::", segmentData);
            console.log("SAMPLES_PER_SEGMENT:::::::", SAMPLES_PER_SEGMENT);
          if (segmentData.length === SAMPLES_PER_SEGMENT) {
              const startTimeSeconds = startIndex / SAMPLING_RATE;
              const endTimeSeconds = endIndex / SAMPLING_RATE;
              segments.push({
                data: segmentData,
                vs: segmentVs,
                vp: segmentVp,
                label: `Session EGM ${startTimeSeconds.toFixed(1)}s - ${endTimeSeconds.toFixed(1)}s`,
                startTime: startTimeSeconds,
                endTime: endTimeSeconds
              });
            }
          }
          
        if (segments.length === 0) {
          // Fallback: render a single short chart for whatever samples are available
          await drawLineChart(heartRateValues, vsValues, vpValues, `Session EGM (${(heartRateValues.length / SAMPLING_RATE).toFixed(2)}s)`, { samplingRate: SAMPLING_RATE, windowSeconds: 10, voltageSpanMv: 15.1 });
          await new Promise((r) => setTimeout(r, 1000));
          try {
            const chartForCapture = hiddenChartRef.current || chartRef.current;
            const base64Image = await captureChartAsBase64({ current: chartForCapture });
            if (base64Image && base64Image.startsWith('data:image')) {
              chartimages.push(base64Image);
              if (charttime.length === 0) charttime.push('Short segment');
            }
          } catch (e) {
            console.error('Failed to capture short session chart:', e);
          }
        } else {
          // Keep only the last 5 segments (most recent data) for the PDF
          const chartSegments = segments.slice(-5);
          console.log(`Using last ${chartSegments.length} of ${segments.length} session segments for PDF`);

          // Generate chart for each 10-second segment
          for (let i = 0; i < chartSegments.length; i++) {
            const segment = chartSegments[i];
            if (segment.data.length > 0) {
              console.log(`Generating session chart ${i + 1} (${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s) with ${segment.data.length} data points...`);
              await drawLineChart(segment.data, segment.vs, segment.vp, segment.label, { samplingRate: SAMPLING_RATE, windowSeconds: 10, voltageSpanMv: 15.1 });
              await new Promise((r) => setTimeout(r, 1000));
              try {
                const chartForCapture = hiddenChartRef.current || chartRef.current;
                const base64Image = await captureChartAsBase64({ current: chartForCapture });
                if (base64Image && base64Image.startsWith('data:image')) {
                  chartimages.push(base64Image);
                  const timeLabel = `${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s`;
                  charttime.push(timeLabel);
                }
              } catch (error) {
                console.error(`Failed to capture session chart ${i + 1}:`, error);
              }
              await new Promise((r) => setTimeout(r, 200));
            }
            }
          }
        } else {
          console.log("No heartRateValues data available for chart generation", {
            heartRateValuesLength: heartRateValues.length,
          });
      }
    } else {
      console.log("No astreambuffer data available");
    }
    
    return { chartimages, charttime };
  };

  // New function to generate EGM data arrays per 10 seconds
  const generateEgmDataPer10Seconds = (egmData) => {
    console.log("Generating EGM data arrays per 10 seconds");
    
    // Constants similar to programmer
    const SAMPLING_RATE = 300; // Hz (200 samples per second)
    const SECONDS_PER_SEGMENT = 10; // 10 seconds per chart
    const SAMPLES_PER_SEGMENT = SAMPLING_RATE * SECONDS_PER_SEGMENT; // 2000 samples per 10-second segment
    
    // Initialize arrays for 10-second segments
    const egmSegments = [];
    
    if (egmData && egmData.voltageValues && Array.isArray(egmData.voltageValues)) {
      const voltageValues = egmData.voltageValues;
      const vsValues = egmData.vsValues || [];
      const vpValues = egmData.vpValues || [];
      
      console.log("Processing EGM data for 10-second segments:", {
        totalSamples: voltageValues.length,
        totalVSEvents: vsValues.filter(v => v > 0).length,
        totalVPEvents: vpValues.filter(v => v > 0).length,
        expectedSegments: Math.ceil(voltageValues.length / SAMPLES_PER_SEGMENT),
        samplesPerSegment: SAMPLES_PER_SEGMENT,
        samplingRate: SAMPLING_RATE
      });
      
      console.log("Segment generation details:");
      console.log("- Each segment needs 2000 samples (200 Hz × 10 seconds)");
      console.log("- Available samples:", voltageValues.length);
      console.log("- Can create", Math.floor(voltageValues.length / SAMPLES_PER_SEGMENT), "full segments");
      console.log("- Remaining samples:", voltageValues.length % SAMPLES_PER_SEGMENT);
      
      // Generate 10-second segments
      for (let startIndex = 0; startIndex < voltageValues.length; startIndex += SAMPLES_PER_SEGMENT) {
        const endIndex = Math.min(startIndex + SAMPLES_PER_SEGMENT, voltageValues.length);
        const segmentData = voltageValues.slice(startIndex, endIndex);
        const segmentVs = vsValues.slice(startIndex, endIndex);
        const segmentVp = vpValues.slice(startIndex, endIndex);
        
        if (segmentData.length === SAMPLES_PER_SEGMENT) {
          const startTimeSeconds = startIndex / SAMPLING_RATE;
          const endTimeSeconds = endIndex / SAMPLING_RATE;
          const segmentIndex = Math.floor(startIndex / SAMPLES_PER_SEGMENT);
          
          // Create segment object similar to pgrogrammer data structure
          const segment = {
            segmentIndex: segmentIndex,
            startTime: startTimeSeconds,
            endTime: endTimeSeconds,
            duration: endTimeSeconds - startTimeSeconds,
            sampleCount: segmentData.length,
            voltageValues: segmentData,
            vsValues: segmentVs.map(val => val > 0 ? 1 : 0), // Convert to boolean
            vpValues: segmentVp.map(val => val > 0 ? 1 : 0), // Convert to boolean
            vsEventCount: segmentVs.filter(v => v > 0).length,
            vpEventCount: segmentVp.filter(v => v > 0).length,
            timestamp: new Date().toISOString(), // Use current time or extract from egmData if available
            label: `EGM ${startTimeSeconds.toFixed(1)}s - ${endTimeSeconds.toFixed(1)}s`
          };
          
          egmSegments.push(segment);
          
          console.log(`Generated segment ${segmentIndex}:`, {
            startTime: segment.startTime,
            endTime: segment.endTime,
            sampleCount: segment.sampleCount,
            vsEvents: segment.vsEventCount,
            vpEvents: segment.vpEventCount,
            voltageRange: {
              min: Math.min(...segment.voltageValues),
              max: Math.max(...segment.voltageValues)
            }
          });
        }
      }
      
      console.log(`Generated ${egmSegments.length} EGM segments`);
      
      // Summary of generated segments
      if (egmSegments.length > 0) {
        console.log("=== EGM SEGMENTS SUMMARY ===");
        egmSegments.forEach((segment, index) => {
          console.log(`Segment ${index}: ${segment.startTime}s - ${segment.endTime}s (${segment.sampleCount} samples)`);
        });
        console.log("=============================");
      }
    } else {
      console.log("No valid EGM data available for segment generation");
    }
    
    return egmSegments;
  };

  // New function to process raw EGM data similar to programmer voltage calculation
  const processRawEgmData = (rawData) => {
    console.log("Processing raw EGM data similar to programmer");
    
    // Constants from programmer
    const ADC_REF_MV = 3300; // Reference voltage in millivolts (from CalyanConstants)
    const ADC_MAX_VAL = 4095; // 12-bit ADC max value
    const EGM_DISPLAY_FACTOR = 1000; // Display factor for voltage scaling
    
    const processedData = {
      voltageValues: [],
      vsValues: [],
      vpValues: [],
      timestamps: []
    };
    
    if (rawData && Array.isArray(rawData)) {
      for (let i = 0; i < rawData.length; i++) {
        const rawValue = rawData[i];
        
        // Extract ADC value (12-bit) - similar to programmer
        const adcValue = rawValue & 0x0FFF;
        
        // Calculate voltage in millivolts - same formula as programmer
        const voltageValue = ((adcValue * ADC_REF_MV) / ADC_MAX_VAL) / EGM_DISPLAY_FACTOR;
        
        // Extract VS and VP markers - same bit positions as programmer
        const vp = rawValue & 0x1000;
        const vs = rawValue & 0x2000;
        
        processedData.voltageValues.push(voltageValue);  
        processedData.vsValues.push(vs > 0 ? 1 : 0);
        processedData.vpValues.push(vp > 0 ? 1 : 0);
        processedData.timestamps.push(i); // Sample index as timestamp
      }
      
      console.log("Processed raw EGM data:", {
        totalSamples: processedData.voltageValues.length,
        voltageRange: {
          min: Math.min(...processedData.voltageValues),
          max: Math.max(...processedData.voltageValues)
        },
        vsEvents: processedData.vsValues.filter(v => v > 0).length,
        vpEvents: processedData.vpValues.filter(v => v > 0).length
      });
    }
    
    return processedData;
  };

  // New function to generate test EGM segments for demonstration
  const generateTestEgmSegments = (numSegments = 5) => {
    console.log(`Generating ${numSegments} test EGM segments for demonstration`);
    
    const SAMPLING_RATE = 300; // Hz
    const SAMPLES_PER_SEGMENT = SAMPLING_RATE * 10; // 2000 samples per 10-second segment
    
    const testSegments = [];
    
    for (let segmentIndex = 0; segmentIndex < numSegments; segmentIndex++) {
      const startTime = segmentIndex * 10;
      const endTime = (segmentIndex + 1) * 10;
      
      // Generate realistic EGM-like voltage data with different characteristics per segment
      const voltageValues = Array.from({length: SAMPLES_PER_SEGMENT}, (_, i) => {
        const time = i / SAMPLING_RATE;
        const baseVoltage = 15.8 + (segmentIndex * 0.2); // Slight variation per segment
        
        // Create realistic EGM waveform with P wave, QRS complex, and T wave
        const pWave = 0.1 * Math.sin(2 * Math.PI * 1.2 * time); // P wave ~1.2 Hz
        const qrsComplex = 0.3 * Math.exp(-Math.pow((time % 0.8 - 0.4) / 0.05, 2)); // QRS every 0.8s
        const tWave = 0.15 * Math.exp(-Math.pow((time % 0.8 - 0.6) / 0.1, 2)); // T wave
        
        // Add segment-specific variations
        let segmentVariation = 0;
        if (segmentIndex === 1) {
          // Second segment: higher heart rate
          segmentVariation = 0.2 * Math.sin(2 * Math.PI * 1.5 * time);
        } else if (segmentIndex === 2) {
          // Third segment: arrhythmia-like pattern
          segmentVariation = 0.15 * Math.sin(2 * Math.PI * 0.6 * time);
        } else if (segmentIndex === 3) {
          // Fourth segment: pacing-like pattern
          segmentVariation = 0.25 * Math.sin(2 * Math.PI * 0.5 * time);
        } else if (segmentIndex === 4) {
          // Fifth segment: normal rhythm with noise
          segmentVariation = 0.1 * Math.sin(2 * Math.PI * 1.0 * time);
        }
        
        const noise = 0.02 * (Math.random() - 0.5);
        
        return baseVoltage + pWave + qrsComplex + tWave + segmentVariation + noise;
      });
      
      // Generate VS events (sensed beats) with different rates per segment
      const vsValues = Array.from({length: SAMPLES_PER_SEGMENT}, (_, i) => {
        const time = i / SAMPLING_RATE;
        let vsInterval = 0.8; // Default 75 BPM
        
        // Different heart rates per segment
        if (segmentIndex === 1) vsInterval = 0.6; // 100 BPM
        else if (segmentIndex === 2) vsInterval = 1.0; // 60 BPM (arrhythmia)
        else if (segmentIndex === 3) vsInterval = 1.2; // 50 BPM (pacing)
        else if (segmentIndex === 4) vsInterval = 0.7; // 85 BPM
        
        return (time % vsInterval < 0.02) ? 1 : 0;
      });
      
      // Generate VP events (paced beats) with different patterns
      const vpValues = Array.from({length: SAMPLES_PER_SEGMENT}, (_, i) => {
        const time = i / SAMPLING_RATE;
        let vpInterval = 1.2; // Default 50 BPM
        
        // Different pacing patterns per segment
        if (segmentIndex === 1) vpInterval = 0; // No pacing
        else if (segmentIndex === 2) vpInterval = 0; // No pacing (arrhythmia)
        else if (segmentIndex === 3) vpInterval = 1.0; // 60 BPM pacing
        else if (segmentIndex === 4) vpInterval = 0; // No pacing
        
        return (vpInterval > 0 && time % vpInterval < 0.02) ? 1 : 0;
      });
      
      const segment = {
        segmentIndex: segmentIndex,
        startTime: startTime,
        endTime: endTime,
        duration: 10.0,
        sampleCount: SAMPLES_PER_SEGMENT,
        voltageValues: voltageValues,
        vsValues: vsValues,
        vpValues: vpValues,
        vsEventCount: vsValues.filter(v => v > 0).length,
        vpEventCount: vpValues.filter(v => v > 0).length,
        timestamp: new Date(Date.now() + segmentIndex * 10000).toISOString(), // 10s apart
        label: `Test EGM ${startTime.toFixed(1)}s - ${endTime.toFixed(1)}s (${segmentIndex === 1 ? 'High Rate' : segmentIndex === 2 ? 'Arrhythmia' : segmentIndex === 3 ? 'Pacing' : segmentIndex === 4 ? 'Normal' : 'Baseline'})`
      };
      
      testSegments.push(segment);
      
      console.log(`Generated test segment ${segmentIndex}:`, {
        startTime: segment.startTime,
        endTime: segment.endTime,
        sampleCount: segment.sampleCount,
        vsEvents: segment.vsEventCount,
        vpEvents: segment.vpEventCount,
        voltageRange: {
          min: Math.min(...segment.voltageValues),
          max: Math.max(...segment.voltageValues)
        },
        label: segment.label
      });
    }
    
    console.log(`Generated ${testSegments.length} test EGM segments`);
    return testSegments;
  };


  // New function to generate charts from real EGM segments
  const generateChartsFromEgmSegments = async (egmSegments, chartimages, charttime) => {
    console.log("Generating charts from real EGM segments...");

    // Keep only the last 5 segments (most recent data) for the PDF
    const chartSegments = egmSegments.slice(-5);
    console.log(`Using last ${chartSegments.length} of ${egmSegments.length} real EGM segments for PDF`);

    for (let i = 0; i < chartSegments.length; i++) {
      const segment = chartSegments[i];
      console.log(`Generating real EGM chart ${i + 1} (${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s) with ${segment.sampleCount} data points...`);
      
      await drawLineChart(segment.voltageValues, segment.vsValues, segment.vpValues, segment.label, { samplingRate: 300, windowSeconds: 10, voltageSpanMv: 15.1 });
      console.log(`Real EGM chart ${i + 1} rendered, waiting for complete render...`);
      await new Promise((r) => setTimeout(r, 1000)); // Wait for chart to render
      
      // Capture chart as base64
      try {
        console.log(`Attempting to capture real EGM chart ${i + 1} as base64...`);
        const chartForCapture = hiddenChartRef.current || chartRef.current;
        const base64Image = await captureChartAsBase64({ current: chartForCapture });
        
        if (base64Image && base64Image.startsWith('data:image')) {
          chartimages.push(base64Image);
          // Use time-based timestamp instead of current time
          const timeLabel = `${segment.startTime.toFixed(1)}s - ${segment.endTime.toFixed(1)}s`;
          charttime.push(timeLabel);
          console.log(`Real EGM chart ${i + 1} captured successfully:`, {
            imageLength: base64Image.length,
            totalImages: chartimages.length,
            segmentSize: segment.sampleCount,
            timeRange: timeLabel,
            imagePreview: base64Image.substring(0, 50) + "..."
          });
        } else {
          console.error(`Invalid base64 image for real EGM chart ${i + 1}:`, base64Image);
        }
      } catch (error) {
        console.error(`Failed to capture real EGM chart ${i + 1}:`, {
          error: error.message,
          chartRefExists: !!(hiddenChartRef.current || chartRef.current),
          isLineChartDataAvailable
        });
      }
      
      await new Promise((r) => setTimeout(r, 200)); // Small delay between charts
    }
    
    return { chartimages, charttime };
  };

  // New function to capture chart as base64
  const captureChartAsBase64 = async (chartRef) => {
    return new Promise((resolve, reject) => {
      try {
        if (!chartRef.current) {
          reject(new Error("Chart ref is null"));
          return;
        }

        // Wait a bit more to ensure chart is fully rendered
        setTimeout(() => {
          try {
            // Method 1: Try Chart.js toBase64Image method
            if (typeof chartRef.current.toBase64Image === 'function') {
              const base64 = chartRef.current.toBase64Image('image/png', 1.0);
              console.log("Captured using toBase64Image method");
              resolve(base64);
              return;
            }

            // Method 2: Try accessing the canvas directly
            const canvas = chartRef.current.canvas;
            if (canvas) {
              const base64 = canvas.toDataURL('image/png', 1.0);
              console.log("Captured using canvas.toDataURL method");
              resolve(base64);
              return;
            }

            // Method 3: Try Chart.js chart instance
            const chartInstance = chartRef.current;
            if (chartInstance && chartInstance.ctx && chartInstance.ctx.canvas) {
              const base64 = chartInstance.ctx.canvas.toDataURL('image/png', 1.0);
              console.log("Captured using chart context canvas");
              resolve(base64);
              return;
            }

            reject(new Error("No valid method found to capture chart"));
          } catch (error) {
            reject(error);
          }
        }, 200);
      } catch (error) {
        reject(error);
      }
    });
  }

    const handlePreview = async (datasync, isPreview) => {
      //process the ecg streams
      selectedDatasynclog = sessiondatasynclogs.get(datasync);
      let astreambuffer = selectedDatasynclog.get('egm');
      let heartRateValues = [];
      let vsValues = [];
      let vpValues = [];
      let scichart;
      let decodedValues;
      let chartimages = [];
      let charttime = [];
      let dataUrl = "";
      let blob ="";

      // Hide any existing chart and show loading state
      setReport(false);
      setIsLineChartDataAvailable(false); //remove the last chart
      setIsGeneratingPDF(true); // Show PDF generation state
      await new Promise((r) => setTimeout(r, 100)); //delay  
      blob = selectedDatasynclog.get("blob");
      if(blob) {
        //blob already generated, reuse and preview it
        setReport(true);
        await new Promise((r) => setTimeout(r, 100)); //delay  
        window.open(URL.createObjectURL(blob),"fpdfviewer");
      } else {
        //blob is not available, generate and preview it

        // Process EGM data using new functions
        let egmSegments = [];
       
        
        // C-03: Removed dead egmparameters fallback — RDP only writes egmpacketdata
        // First try session-based EGM data
        if (astreambuffer) {
          console.log("Processing session-based EGM data...");
          const sessionResult = await processSessionEgmData(astreambuffer, chartimages, charttime);
          chartimages = sessionResult.chartimages;
          charttime = sessionResult.charttime;
        }

        // Only if no charts came from session, try direct egmpacketdata
        if (chartimages.length === 0 && selectedDeviceData?.features?.egmpacketdata?.properties) {
          console.log("No session charts generated, falling back to direct egmpacketdata...");
          const egmData = selectedDeviceData.features.egmpacketdata.properties;
          egmSegments = generateEgmDataPer10Seconds(egmData);
          const egmResult = await processEgmDataForCharts(egmData, chartimages, charttime);
          chartimages = egmResult.chartimages;
          charttime = egmResult.charttime;
        }
        
        // Generate charts from real EGM segments first
        if (egmSegments.length > 0) {
          console.log("Generating charts from real EGM segments..."); 
          const realEgmResult = await generateChartsFromEgmSegments(egmSegments, chartimages, charttime);
          chartimages = realEgmResult.chartimages;
          charttime = realEgmResult.charttime;
        }
        
        
      let parameters = selectedDatasynclog.get("parameters");
      if(_.isEmpty(parameters)){
        parameters = selectedDeviceData.features?.deviceparameters?.properties;
      }
      
      // FIX #14: errcodes is now { mainprocessorerror, pacingengineerror } instead of an array
      let deviceerrorInfo = null;
      let deviceerrors = selectedDatasynclog.get("errors")
      if (!_.isEmpty(deviceerrors)) {
        let errParts = [];
        if (deviceerrors.errcodes?.mainprocessorerror) errParts.push('MP: ' + deviceerrors.errcodes.mainprocessorerror);
        if (deviceerrors.errcodes?.pacingengineerror) errParts.push('PE: ' + deviceerrors.errcodes.pacingengineerror);
        deviceerrorInfo = formatAppDate(deviceerrors.ts) + " " + errParts.join(', ');
    }
      let syncdate = datasync.split('T')[0];

      const syncdateFmt = formatAppDate(syncdate);

    const inputs = [
      {
        "PatientId": selectedDeviceData ? selectedDeviceData.attributes.subjectId : "",
        "DOB": (() => {
          // First try eCRF data
          if (!_.isEmpty(subjectData)) {
            return formatAppDate(subjectData.attributes.dob);
          }
          // Fallback to patient parameters
          if (selectedDeviceData?.features?.patientinfo?.properties?.dob) {
            return formatAppDate(selectedDeviceData.features.patientinfo.properties.dob);
          }
          return "";
        })(),
        // FIX #17: Fallback reads mainprocessorerror/pacingengineerror (not errors.processed)
        "Alerts": (() => {
          if (deviceerrorInfo) return deviceerrorInfo;
          const ds = selectedDeviceData?.features?.devicestatus?.properties;
          let parts = [];
          if (ds?.mainprocessorerror && ds.mainprocessorerror !== "No Errors") parts.push('MP: ' + ds.mainprocessorerror);
          if (ds?.pacingengineerror && ds.pacingengineerror !== "No Errors") parts.push('PE: ' + ds.pacingengineerror);
          return parts.join(', ') || "";
        })(),
        "Patient indication": (() => {
          // Add patient initials if available
          const patientInitials = selectedDeviceData?.features?.patientinfo?.properties?.initials;
          if (patientInitials) {
            return `Patient initials: ${patientInitials}`;
          }
          return "";
        })(),
        "model": (() => {
          // Use patient parameters model if available, fallback to device attributes
          const patientModel = selectedDeviceData?.features?.patientinfo?.properties?.modelnumber;
          if (patientModel) {
            return patientModel;
          }
          return selectedDeviceData ? selectedDeviceData.attributes.model : "";
        })(),
        "device type": (() => {
          // Combine model and technology for better device identification
          if (selectedDeviceData?.attributes?.model && selectedDeviceData?.attributes?.technology) {
            return `${selectedDeviceData.attributes.model} ${selectedDeviceData.attributes.technology}`;
          }
          if (selectedDeviceData?.attributes?.technology) {
            return selectedDeviceData.attributes.technology;
          }
          return selectedDeviceData?.attributes?.model || "";
        })(),
        "implant date": (() => {
          // First try eCRF_implant data
          if (implantData && implantData[IMPLANT_DATE_OF_VISIT]?.value) {
            return formatAppDate(implantData[IMPLANT_DATE_OF_VISIT].value);
          }
          // Fallback to patientinfo
          if (selectedDeviceData?.features?.patientinfo?.properties?.implantdate) {
            return formatAppDate(selectedDeviceData.features.patientinfo.properties.implantdate);
          }
          // Fallback to device mfgdate (manufacturing/implant date)
          if (selectedDeviceData?.attributes?.mfgdate) {
            return formatAppDate(selectedDeviceData.attributes.mfgdate);
          }
          // Last fallback to device implantDate field if set in dashboard
          if (selectedDeviceData?.implantDate) {
            return formatAppDate(selectedDeviceData.implantDate);
          }
          return "";
        })(),
        "serial no": (() => {
          // Use patient parameters serial if available, fallback to device attributes
          const patientSerial = selectedDeviceData?.features?.patientinfo?.properties?.serialnumber;
          if (patientSerial) {
            return patientSerial;
          }
          return selectedDeviceData ? selectedDeviceData.attributes.serialnumber : "";
        })(),
        "Pacing mode": parameters?.pacingmode || selectedDeviceData?.features?.deviceparameters?.properties?.pacingmode || "",
        "last interrogation": syncdateFmt || "",
        "Current voltage": (() => {
          const sessionVoltage = selectedDatasynclog.get("batteryvoltage");
          if (sessionVoltage !== -1 && sessionVoltage != null && sessionVoltage !== undefined) {
            return String(sessionVoltage) + "V";
          }
          // RDP writes batteryvoltage.properties.batteryvoltage (voltage in volts)
          const deviceVoltage = selectedDeviceData?.features?.batteryvoltage?.properties?.batteryvoltage;
          if (deviceVoltage != null && deviceVoltage !== undefined) {
            return String(deviceVoltage) + "V";
          }
          // Fallback: get latest from voltage trend data
          const voltageValues = selectedDeviceData?.features?.batteryvoltagetrendmin?.properties?.voltagevaluesv;
          if (Array.isArray(voltageValues) && voltageValues.length > 0) {
            const lastVoltage = voltageValues.find(v => v > 0) ?? voltageValues[voltageValues.length - 1];
            if (lastVoltage != null && lastVoltage > 0) {
              return String(lastVoltage.toFixed(2)) + "V";
            }
          }
          return "";
        })(),
        "Current impedance": (() => {
          const sessionImpedance = selectedDatasynclog.get("currentleadimpedance");
          if (sessionImpedance !== -1 && sessionImpedance != null && sessionImpedance !== undefined && sessionImpedance > 0) {
            return String(Math.round(Number(sessionImpedance))) + "Ω";
          }
          // RDP writes leadimpedance.properties.impedanceohms as a formatted string like "456.78"
          const deviceImpedanceStr = selectedDeviceData?.features?.leadimpedance?.properties?.impedanceohms;
          if (deviceImpedanceStr != null && deviceImpedanceStr !== undefined) {
            const deviceImpedance = parseFloat(deviceImpedanceStr);
            if (!isNaN(deviceImpedance) && deviceImpedance > 0) {
              return String(Math.round(deviceImpedance)) + "Ω";
            }
          }
          // If impedance is 0 or invalid, indicate measurement issue with shorter text
          return "0Ω (Error)";
        })(),
        "measured threshold": (() => {
          // Try to get from pacing trends if available
          // RDP writes sensehistogram.properties.percentagevalues (array of strings like "1.23")
          if (selectedDeviceData?.features?.sensehistogram?.properties?.percentagevalues) {
            const sensingValues = selectedDeviceData.features.sensehistogram.properties.percentagevalues;
            // Check percentage values for meaningful sensing data
            if (sensingValues[4] && parseFloat(sensingValues[4]) > 0) {
              const result = String(parseFloat(sensingValues[4]).toFixed(2)) + " %*";
              console.log("Measured threshold result:", result);
              return result;
            }
            if (sensingValues[5] && parseFloat(sensingValues[5]) > 0) {
              const result = String(parseFloat(sensingValues[5]).toFixed(2)) + " %";
              console.log("Measured threshold result (index 5):", result);
              return result;
            }
          }
          console.log("Measured threshold: Not measured");
          return "Not measured";
        })(),
        "date measured": syncdateFmt || "",
        "programmed output": (() => {
          // Try to get from pacing trends - interpret values more carefully
          // RDP writes pacehistogram.properties.percentagevalues (array of strings)
          if (selectedDeviceData?.features?.pacehistogram?.properties?.percentagevalues) {
            const pacingValues = selectedDeviceData.features.pacehistogram.properties.percentagevalues;
            if (pacingValues[3] && parseFloat(pacingValues[3]) > 0 && parseFloat(pacingValues[3]) < 50) {
              const result = String(parseFloat(pacingValues[3]).toFixed(2)) + " %";
              console.log("Programmed output result (index 3):", result);
              return result;
            }
          }
          console.log("Programmed output: Not programmed");
          return "Not programmed";
        })(),
        "measured R-wave": (() => {
          // First try weekly R-wave parameters
          // RDP writes rwaveamplitudeweeklymin.properties.rwaveamplitudevaluesuv (array of strings like "1.23" or "NaN")
          if (selectedDeviceData?.features?.rwaveamplitudeweeklymin?.properties?.rwaveamplitudevaluesuv) {
            const rwaveValues = selectedDeviceData.features.rwaveamplitudeweeklymin.properties.rwaveamplitudevaluesuv;
            // Get the latest non-NaN value (values are strings)
            for (let i = rwaveValues.length - 1; i >= 0; i--) {
              const val = parseFloat(rwaveValues[i]);
              if (!isNaN(val) && val > 0) {
                return String(val.toFixed(2)) + " uv";
              }
            }
          }
          // Also try rwaveamplitude (single on-command reading)
          if (selectedDeviceData?.features?.rwaveamplitude?.properties?.rwaveamplitudemv) {
            const rwaveStr = selectedDeviceData.features.rwaveamplitude.properties.rwaveamplitudemv;
            const rwaveVal = parseFloat(rwaveStr);
            if (!isNaN(rwaveVal) && rwaveVal > 0) {
              return String(rwaveVal.toFixed(2)) + " mv";
            }
          }
          return "Not measured";
        })(),
        "programmed sensetivity": (() => {
          const sens = parameters?.sensitivity ?? selectedDeviceData?.features?.deviceparameters?.properties?.sensitivity;
          if (sens != null && sens !== undefined) {
            return String(sens) + " mv";
          }
          return "Not available";
        })(),
        "refactory period": (() => {
          const rp = parameters?.refractoryperiod ?? selectedDeviceData?.features?.deviceparameters?.properties?.refractoryperiod;
          if (rp != null && rp !== undefined) {
            return String(rp) + " msec";
          }
          return "Not available";
        })(),
        "blanking period": (() => {
          const bp = parameters?.blankpostvs ?? selectedDeviceData?.features?.deviceparameters?.properties?.blankpostvs;
          if (bp != null && bp !== undefined) {
            return String(bp) + " msec";
          }
          return "Not available";
        })(),
        "measured impedance": (() => {
          // RDP writes leadimpedance.properties.impedanceohms as a formatted string
          const impedanceStr = selectedDeviceData?.features?.leadimpedance?.properties?.impedanceohms;
          if (impedanceStr != null && impedanceStr !== undefined) {
            const impedanceValue = parseFloat(impedanceStr);
            if (!isNaN(impedanceValue) && impedanceValue > 0) {
              return String(impedanceValue) + "Ω";
            }
          }
          return "0Ω (Error)";
        })(),
        "ERI Voltage": "",
        "estimated longetivity": (() => {
          // Prefer the per-session value captured from the historical SSE
          // stream — without this, every sync log shows the same (latest)
          // value from selectedDeviceData. Fall back to current device state.
          const sessionDays = selectedDatasynclog.get("daysToEos");
          let raw = (sessionDays != null && sessionDays !== -1)
            ? sessionDays
            : selectedDeviceData?.features?.batteryparameter?.properties?.["Days to EOS"];
          if (raw == null) return "";
          const n = Math.round(Number(raw));
          if (!Number.isFinite(n) || n < 0) return "";
          return `${n} days`;
        })(),
        "parameter summary graph": (() => {
          // Add total beats information from pacing trends
          // RDP writes totalbeats in both sensehistogram and pacehistogram
          const totalBeats = selectedDeviceData?.features?.sensehistogram?.properties?.totalbeats ?? selectedDeviceData?.features?.pacehistogram?.properties?.totalbeats;
          if (totalBeats && totalBeats > 0) {
            return `Total beats: ${totalBeats.toLocaleString()}`;
          }
          return "";
        })(),
        "flexarm impedance graph": (() => {
          // RDP writes devicestatus.properties with processor error info (not comm stats)
          const deviceStatus = selectedDeviceData?.features?.devicestatus?.properties;
          if (deviceStatus) {
            const errors = [];
            if (deviceStatus.mainprocessorerror && deviceStatus.mainprocessorerror !== "No Errors") {
              errors.push(`MP Error: ${deviceStatus.mainprocessorerror}`);
            }
            if (deviceStatus.pacingengineerror && deviceStatus.pacingengineerror !== "No Errors") {
              errors.push(`PE Error: ${deviceStatus.pacingengineerror}`);
            }
            return errors.length > 0 ? errors.join(", ") : "No errors";
          }
          return "";
        })(),
        "interrogation date": syncdateFmt || "",
        "device alerts": (() => {
          let alerts = [];
          
          // Add session-specific errors
          if (deviceerrorInfo) {
            alerts.push(deviceerrorInfo);
          }
          
          // Add device status errors (RDP writes devicestatus with processor error flags)
          const deviceStatus = selectedDeviceData?.features?.devicestatus?.properties;
          if (deviceStatus) {
            if (deviceStatus.mainprocessorerror && deviceStatus.mainprocessorerror !== "No Errors") {
              alerts.push(`MP errors: ${deviceStatus.mainprocessorerror}`);
            }
            if (deviceStatus.pacingengineerror && deviceStatus.pacingengineerror !== "No Errors") {
              alerts.push(`PE errors: ${deviceStatus.pacingengineerror}`);
            }
            if (deviceStatus.mainprocessorresetreason && deviceStatus.mainprocessorresetreason !== "No Reset") {
              alerts.push(`MP reset: ${deviceStatus.mainprocessorresetreason}`);
            }
          }
          
          // Add lead impedance warning if abnormal
          const leadImpedanceStr = selectedDeviceData?.features?.leadimpedance?.properties?.impedanceohms;
          if (leadImpedanceStr === "0" || leadImpedanceStr === "0.00" || parseFloat(leadImpedanceStr) === 0) {
            alerts.push("Lead impedance measurement error");
          }
          
          return alerts.length > 0 ? alerts.join("; ") : "";
        })(),
        "magnetic response": (() => {
          // RDP writes batteryparameter.properties.magnetPickupsDetected (flat, no nesting)
          const magnetPickups = selectedDeviceData?.features?.batteryparameter?.properties?.magnetPickupsDetected;
          if (magnetPickups != null && magnetPickups !== undefined) {
            return magnetPickups > 0 ? "Detected (" + String(magnetPickups) + " events)" : "Not detected";
          }
          return "Not monitored";
        })(),
        "pacing amplitude": (() => {
          const amp = parameters?.pacingamplitude ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingamplitude;
          if (amp != null && amp !== undefined) {
            return String(amp) + "V";
          }
          // Check battery parameters for pacing pulse data (RDP: batteryparameter, flat properties)
          const batteryParamsAmp = selectedDeviceData?.features?.batteryparameter?.properties;
          if (batteryParamsAmp?.pacingPulsesDelivered > 0) {
            return "Active pacing (amplitude not reported)";
          }
          return "Not available";
        })(),
        "pacing pulse width": (() => {
          const ppw = parameters?.pacingpulsewidth ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingpulsewidth;
          if (ppw != null && ppw !== undefined) {
            return String(ppw) + " mSec";
          }
          // Check batteryparameter for pacing activity (flat properties from RDP)
          const batteryParamsPW = selectedDeviceData?.features?.batteryparameter?.properties;
          if (batteryParamsPW?.pacingPulsesDelivered > 0) {
            return "Active pacing (width not reported)";
          }
          return "Not available";
        })(),
        "blanking": (() => {
          const blk = parameters?.blankpostvs ?? selectedDeviceData?.features?.deviceparameters?.properties?.blankpostvs;
          if (blk != null && blk !== undefined) {
            return String(blk) + " mSec";
          }
          return "Not available";
        })(),
        "sensitivity": (() => {
          const sens = parameters?.sensitivity ?? selectedDeviceData?.features?.deviceparameters?.properties?.sensitivity;
          if (sens != null && sens !== undefined) {
            return String(sens) + "mv";
          }
          // Fallback: check sensehistogram percentage values
          if (selectedDeviceData?.features?.sensehistogram?.properties?.percentagevalues) {
            const sensingPct = selectedDeviceData.features.sensehistogram.properties.percentagevalues;
            if (sensingPct[4] && parseFloat(sensingPct[4]) > 0) {
              return String(parseFloat(sensingPct[4]).toFixed(2)) + " %*";
            }
          }
          return "Not available";
        })(),
        "mode": (() => {
          // Use technology as primary mode indicator
          if (selectedDeviceData?.attributes?.technology) {
            return selectedDeviceData.attributes.technology;
          }
          // Try from session/device parameters (support both camelCase and lowercase)
          const mode = parameters?.pacingmode ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingmode;
          return mode || "";
        })(),
        "rate": (() => {
          const rate = parameters?.pacingrate ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingrate;
          if (rate != null && rate !== undefined) {
            return String(rate) + " bpm";
          }
          // bpm is derived from pacingrate above
          // Check batteryparameter for device activity (RDP: flat properties)
          const batteryParamsRate = selectedDeviceData?.features?.batteryparameter?.properties;
          if (batteryParamsRate?.pacingPulsesDelivered > 0) {
            return "Device active";
          }
          return "Not available";
        })(),
        "adaptive mode": (() => {
          // RDP writes batteryparameter.properties.rateResponseActivations (flat)
          const batteryParamsAdapt = selectedDeviceData?.features?.batteryparameter?.properties;
          if (batteryParamsAdapt?.rateResponseActivations != null) {
            if (batteryParamsAdapt.rateResponseActivations > 0) {
              return "Active (" + String(batteryParamsAdapt.rateResponseActivations) + " activations)";
            } else {
              return "Inactive (0 activations)";
            }
          }
          // Check technology for rate adaptive indicators (R in mode name)
          if (selectedDeviceData?.attributes?.technology?.includes('R')) {
            return "Rate Responsive Mode";
          }
          return "Not available";
        })(),
        "low activity rate": (() => {
          // Rate config may come from rateresponseparameters if available
          const rateRespParams = selectedDeviceData?.features?.rateresponseparameters?.properties;
          if (rateRespParams?.rateresplookbackbuffdepth != null) {
            return "Rate response active";
          }
          return "Not available";
        })(),
        "base rate": (() => {
          // Base rate comes from deviceparameters (opcode 0x04)
          const rateBase = parameters?.pacingrate ?? parameters?.pacingRate ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingrate ?? selectedDeviceData?.features?.deviceparameters?.properties?.pacingRate;
          if (rateBase != null && rateBase !== undefined) {
            return String(rateBase) + " bpm";
          }
          return "Not available";
        })(),
        "high activity rate": (() => {
          // Based on actual data, rate parameters are undefined in trends
          // Rate adaptive parameters are not available in current device features
          return "Not available";
        })(),
        "paced beats": (() => {
          // Show total beats information here where it belongs
          // RDP writes totalbeats in ventricularmarkers (total VP+VS counts)
          const ventMarkers = selectedDeviceData?.features?.ventricularmarkers?.properties;
          if (ventMarkers?.totalcount && ventMarkers.totalcount > 0) {
            return String(ventMarkers.totalcount.toLocaleString()) + " total beats";
          }
          // Also check histogram totalbeats
          const histTotalBeats = selectedDeviceData?.features?.pacehistogram?.properties?.totalbeats ?? selectedDeviceData?.features?.sensehistogram?.properties?.totalbeats;
          if (histTotalBeats && histTotalBeats > 0) {
            return String(histTotalBeats.toLocaleString()) + " total beats";
          }
          return "";
        })(),
        "paced beats percent": (() => {
          const sessionVp = selectedDatasynclog.get("vp");
          if (sessionVp != -1 && sessionVp != null && sessionVp != undefined) {
            return String(sessionVp);
          }
          if (selectedDeviceData?.features?.ventricularmarkers?.properties?.vppercentage != null) {
            return String(selectedDeviceData.features.ventricularmarkers.properties.vppercentage);
          }
          return "";
        })(),
        "sensed beats": "",
        "sensed beats percent": (() => {
          const sessionVs = selectedDatasynclog.get("vs");
          if (sessionVs != -1 && sessionVs != null && sessionVs != undefined) {
            return String(sessionVs);
          }
          if (selectedDeviceData?.features?.ventricularmarkers?.properties?.vspercentage != null) {
            return String(selectedDeviceData.features.ventricularmarkers.properties.vspercentage);
          }
          return "";
        })(),
        "time1": "",
        "onset1": "",
        "onset2": "",
        "onset3": "",
        "ventricular histogram graph": "",
        "time2": "",
        "time3": "",
        "patient id": selectedDeviceData ? selectedDeviceData.attributes.subjectId : "",
        "graph1": chartimages[0] || "",
        "graph2": chartimages[1] || "",
        "graph3": chartimages[2] || "",
        "graph4": chartimages[3] || "",
        "graph5": chartimages[4] || "",
        "graph-date1": charttime[0] || "",
        "graph-date2": charttime[1] || "",
        "graph-date3": charttime[2] || "",
        "graph-date4": charttime[3] || "",
        "graph-date5": charttime[4] || ""
      }
    ];

    await new Promise((r) => setTimeout(r, 100)); //delay

    let pdf;
    if(isPreview) {
      setReport(true);
      setIsGeneratingPDF(false); // Hide PDF generation state
  /*     const viewer = new Viewer({ domContainer:document.getElementById('pdfpreview'), template:pdftemplate, inputs }); */
      
      //print pdf
      pdf = await generate({template: pdftemplate, inputs, plugins: { text, image } });
      // Browser
      blob = new Blob([pdf.buffer], { type: 'application/pdf' });
      selectedDatasynclog.set("blob",blob) //save the blob for next use    
      pdfviewerwindow = window.open(URL.createObjectURL(blob),"fpdfviewer");  
      
    } else {
      setIsGeneratingPDF(false); // Hide PDF generation state
      //print pdf
      pdf = await generate({template: pdftemplate, inputs, plugins: { text, image } });
      // Browser
      let blob = new Blob([pdf.buffer], { type: 'application/pdf' });
      //window.open(URL.createObjectURL(blob));
      saveAs(blob, selectedDeviceData ? selectedDeviceData.attributes.subjectId : "DFU3287358" + 'Interrogation_Report.pdf');
    }
      }
    };



  return (
    <div style={{ width: "100%", height: "75vh", display: "flex" }} className='datasync_container'>
      {/*     <IonRow>  */}
      {!isLoaded && <IonSpinner name="crescent"> </IonSpinner>}
      {!isLoaded && loadingProgress && <div style={{marginLeft: "10px", fontSize: "14px", color: "#666"}}>{loadingProgress}</div>}
      {!isDataSyncAvailable && <IonLabel>{"No data sync found for " + selectedDeviceData.attributes.subjectId}</IonLabel>}
      <div style={{ width: "40%", height: '100%', border: "1px solid #999999", borderRadius: '5px', padding: "15px", }}>
        <div style={{ display: "flex", justifyContent: 'space-between', paddingBottom: "15px" }}>
          <div style={{ fontSize: "14px", color: "#535352", paddingLeft: '20px' }}>SYNC LOG</div>
          <div style={{ fontSize: "24px", color: "#535352", paddingRight: "10px" }}><IoSyncSharp /></div>
        </div>

        <div style={{ display: "flex", justifyContent: 'center' }}>
          <div style={{ width: '100%', height: "60vh", border: "1px solid #999999", borderRadius: "5px", padding: "15px", overflowY: "scroll" }}>
            {syncData?.map((item, index) => {
              const syncedAt = formatAppDateTime(item);
              return (
                <div data-testid={"TDATASYNCCLICK_"+index} className={selected == item ? "datasync_log_container_selected" : "datasync_log_container"} onClick={(e) => {
                  setSelected(item)
                  setSyncDataDisplay(item)
                  setIndexValue(index)
                  handlePreview(item, true)
                }} key={index}>
                  <div>
                    <div data-testid={"TDATASYNCID_"+index} className='datasync_sync_id'>ID:{selectedDeviceData.attributes.subjectId} SYNC</div>
                    <div style={{ display: "flex" }}>
                      <div style={{ paddingRight: '20px', fontSize: "14px", color: "#535352" }}>
                        {syncedAt}
                      </div>
                    </div>
                  </div>
                  <div>
{/*                     {indexValue == index ? <IonButton onClick={(e) => handlePreview(item, false)} style={{ backgroundColor: "#22BCBD", letterSpacing: "0.2em" }}>Print/Save</IonButton> : null} */}
                    <IoSyncSharp style={{ fontSize: "24px", color: "#535352", marginLeft: "20px" }} />
                  </div>
                </div>
              )
            })}
            {loadingMore && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "15px", color: "#666" }}>
                <IonSpinner name="crescent" style={{ marginRight: "8px", width: "20px", height: "20px" }} />
                <span style={{ fontSize: "13px" }}>{loadingProgress || "Loading older sync data..."}</span>
              </div>
            )}
          </div>
        </div>

      </div>
{/*       {report? 
      <div style={{width:"55%",marginLeft:"15px",height:"100%",border:"1px solid #999999",padding:"15px",borderRadius:"5px"}}>
            <div id='container' style={{width:"100%",height:"100%",border:"1px solid #999999",borderRadius:"5px"}}>
            <div style={{height:"100%"}} id='pdfpreview' />
          </div>
      </div>
      :null} */}
      {report && <iframe data-testid="TIFRAME" id="fpdfpreview" name="fpdfviewer" title="Report Preview" src="about:blank" allow="" width="100%" height="100%"> </iframe>}
      
      {/* PDF Generation Loading State */}
      {isGeneratingPDF && 
      <div style={{width:"100%",height:"50%",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
        <IonSpinner name="crescent" style={{marginBottom:"10px"}} />
        <div style={{fontSize:"14px",color:"#666"}}>Generating PDF report...</div>
      </div>}
      
{/*     </IonRow>  
    <IonRow>   */}  
      {/* Chart display area - only show when not generating PDF */}
      {!report && !isGeneratingPDF && isLineChartDataAvailable && 
      <div style={{width:"100%",height:"50%",display:"flex"}}>
        <Line
          data={lineChartData.data}
          options={lineChartData.options}
          ref={chartRef}
          width={1300}
          height={180}
        />
      </div>}
      
      {/* Hidden chart container for image generation - always available */}
      <div style={{
        position: "absolute", 
        top: "-9999px", 
        left: "-9999px", 
        width: "1300px", 
        height: "180px",
        visibility: "hidden"
      }}>
        {isLineChartDataAvailable && <Line data={lineChartData.data} options={lineChartData.options} ref={hiddenChartRef} width={1300} height={180}/>}
      </div>
{/*       </IonRow>    */}
    </div>
  )
}

export default Datasync